import { render } from "./ContactDetailsRow.vue?vue&type=template&id=92b1258c"
import script from "./ContactDetailsRow.vue?vue&type=script&lang=js"
export * from "./ContactDetailsRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__